"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetDefaultYAxis = exports.GROW_Y_DOMAIN = void 0;
var react_1 = __importDefault(require("react"));
var recharts_1 = require("recharts");
var Colors_1 = require("@CommonFrontend/Styles/Colors");
var NiceScale_1 = require("./NiceScale");
var CommonUtils_1 = require("@CommonFrontendBackend/Utils/CommonUtils");
var tokens_1 = require("@qwilr/kaleidoscope/tokens");
var DEFAULT_MIN_Y_TICKS = 5;
exports.GROW_Y_DOMAIN = 1.05;
function getTicksForYAxis(maxNumber, minTicks, maxTicks, zeroOffset, removeDecimalTicks) {
    var dataMax = maxNumber === 0 ? 1 : maxNumber;
    var _a = (0, NiceScale_1.calculateNiceScale)(minTicks - 1, maxTicks - 1, 0, dataMax), tickSpacing = _a.tickSpacing, niceMin = _a.niceMin, niceMax = _a.niceMax;
    var ticks = [];
    for (var tickValue = niceMin; tickValue <= niceMax; tickValue = (0, CommonUtils_1.safePlus)(tickValue, tickSpacing)) {
        if (removeDecimalTicks && !Number.isInteger(tickValue))
            continue;
        ticks.push(tickValue);
    }
    if (zeroOffset === 0) {
        return { ticks: ticks, niceMax: niceMax };
    }
    else {
        var negativeTickSize = (zeroOffset * niceMax) / (1 - zeroOffset);
        return { ticks: __spreadArray([-negativeTickSize], __read(ticks), false), niceMax: niceMax };
    }
}
function formatTick(tickValue, formatter) {
    if (tickValue < 0) {
        return "";
    }
    if (formatter) {
        return formatter(tickValue);
    }
    return String(tickValue);
}
function GetDefaultYAxis(_a) {
    var dataMax = _a.dataMax, yAxisId = _a.yAxisId, isMobile = _a.isMobile, _b = _a.config, config = _b === void 0 ? {} : _b, _c = _a.zeroOffset, zeroOffset = _c === void 0 ? 0 : _c;
    var _d = config.type, type = _d === void 0 ? "number" : _d, _e = config.minTicks, minTicks = _e === void 0 ? DEFAULT_MIN_Y_TICKS : _e, maxTicks = config.maxTicks, tickColor = config.tickColor, tickFont = config.tickFont, tickLetterSpacing = config.tickLetterSpacing, tickFormatter = config.tickFormatter, label = config.label, _f = config.removeDecimalTicks, removeDecimalTicks = _f === void 0 ? false : _f;
    var actualMaxTicks = maxTicks !== null && maxTicks !== void 0 ? maxTicks : minTicks + 3;
    if (actualMaxTicks < minTicks) {
        throw Error("`maxTicks` must be greater than or equal to `minTicks`");
    }
    var _g = getTicksForYAxis(dataMax, minTicks, actualMaxTicks, zeroOffset, removeDecimalTicks), ticks = _g.ticks, niceMax = _g.niceMax;
    var baseWidth = isMobile ? 35 : 50;
    var tickFormatting = {
        fill: tickColor || tokens_1.tokens.color.headingSecondary,
        fontSize: 14,
        fontWeight: 600,
    };
    if (tickFont)
        tickFormatting["fontFamily"] = tickFont;
    if (tickLetterSpacing)
        tickFormatting["letterSpacing"] = tickLetterSpacing;
    return (react_1.default.createElement(recharts_1.YAxis, { yAxisId: yAxisId, type: type, tickLine: false, tickFormatter: function (tickValue) { return formatTick(tickValue, tickFormatter); }, ticks: ticks, axisLine: { stroke: Colors_1.ColorPalette.Slate, opacity: 0.5 }, width: baseWidth + (label ? 16 : 0), domain: [0, niceMax * exports.GROW_Y_DOMAIN], tick: tickFormatting, label: label
            ? {
                value: label,
                angle: -90,
                position: "insideLeft",
                fill: Colors_1.ColorPalette.Slate,
                opacity: 0.5,
                style: { textAnchor: "middle" },
            }
            : undefined }));
}
exports.GetDefaultYAxis = GetDefaultYAxis;
